// extracted by mini-css-extract-plugin
module.exports = {"border-style-solid":"box_border-style-solid__E35PN","border-style-dashed":"box_border-style-dashed___eGy1","border-style-dotted":"box_border-style-dotted__rQRvc"};